import React, { useState } from "react";
import ModalVideo from "react-modal-video";

const VideoGalleryContent = [
  {
    img: "cbl-video-1",
    text1: "Integration (Product of 2 different trigo terms)",
    text2: "JC H2 Maths",
    animationDelay: "",
    videoId: "MyiRhnZAwnE"
  },
  {
    img: "cbl-video-2",
    text1: "Extract (Sampling Distribution)",
    text2: "JC H2 Maths",
    animationDelay: "50",
    videoId: "s8-CSOCxsKk"
  },
  {
    img: "cbl-video-3",
    text1: "Physics Gravitational Field.",
    text2: "JC Physics",
    animationDelay: "100",
    videoId: "CxNAH0X7ye0"
  },
  {
    img: "cbl-video-4",
    text1: "Easy reference to extracts",
    text2: "JC2 Econs",
    animationDelay: "150",
    videoId: "peiI3NH-8yg"
  },
  {
    img: "cbl-video-5",
    text1: "Where does bad light end up?",
    text2: "Pri Science",
    animationDelay: "50",
    videoId: "TbVjc-4etdU"
  },
  {
    img: "cbl-video-6",
    text1: "Why are obtuse angles always sad?",
    text2: "Sec 1 Maths",
    animationDelay: "100",
    videoId: "cAyayfQ30Po"
  },
];

const VideoGallery = () => {
  const [isOpen, setOpen] = useState(false);
  const [currentVideoId, setCurrentVideoId] = useState(false);
  
  return (
    <div className="row justify-content-center">
      <ModalVideo
        channel="youtube"
        autoplay
        isOpen={isOpen}
        videoId={currentVideoId}
        onClose={() => setOpen(false)}
      />
      {VideoGalleryContent.map((val, i) => (
        <div
          className="col-xl-4 col-lg-4 col-sm-6"
          data-aos="fade-up"
          data-aos-duration="1200"
          data-aos-delay={val.animationDelay}
          key={i}
        > 
          <div className="block-style-twentyOne">
            <img src={`images/site/programmes/${val.img}.webp`} alt="" className="w-100" />
            <div className="d-flex align-items-center justify-content-center flex-column video-button">
              <span>
                {val.text1} <br /> {val.text2}
              </span>
              <span
                className="icon d-flex align-items-center justify-content-center"
                onClick={() => { setOpen(true); setCurrentVideoId(val.videoId); }}
              >
                <img src="images/icon/118.svg" alt="" />
              </span>
            </div>
          </div>
          {/* /.block-style-twentyOne */}
        </div>
      ))}
    </div>
  );
};

export default VideoGallery;
